import React, { memo, useState, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useRocketDryFunctions } from 'Context/RocketDry';

import { EditMoistureLogReadingModal } from 'Components/RocketDry/EditLogModal';

import { numberInputRegex } from 'Containers/RocketDry/helpers';

import { parseISODate } from 'Utils/helpers';

import { updateDryingLog } from 'Containers/RocketDry/actions';
import { areEqual } from 'Utils/equalityChecks';

function EditMoistureLogReadingModalContainer() {
  const dispatch = useDispatch();

  const {
    selectedRoomId,
    isEditMoistureLogReadingModalOpen,
    setIsEditMoistureLogReadingModalOpen,
    selectedMoistureLog,
    setSelectedMoistureLog,
    setMoistureLogRefetch,
  }: any = useRocketDryFunctions();

  const [latestAverage, setLatestAverage] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [removed, setRemoved] = useState(false);
  const [recordTime, setRecordTime] = useState(undefined);

  useEffect(() => {
    if (selectedMoistureLog) {
      setLatestAverage(selectedMoistureLog.reading);
      setRemoved(selectedMoistureLog.removed);
      setRecordTime(parseISODate(selectedMoistureLog.created_at));
    }
  }, [selectedMoistureLog]);

  const onChangeLatestAverage = useCallback(({ target: { value } }) => {
    const filtered = value.replace(numberInputRegex, '');
    setLatestAverage(filtered);
  }, []);

  const onRemovedCheckboxClick = useCallback(() => {
    setRemoved((value) => !value);
  }, []);

  const onCloseModal = useCallback(() => {
    setIsEditMoistureLogReadingModalOpen(false);
    setLatestAverage('');
    setRemoved(false);
    setIsProcessing(false);
    setSelectedMoistureLog(undefined);
  }, []);

  const onSaveButtonClick = useCallback(async () => {
    if (selectedRoomId && selectedMoistureLog) {
      setIsProcessing(true);
      const params: any = {
        removed,
        created_at: new Date(recordTime).toISOString(),
      };
      if (!removed) {
        params.reading = latestAverage;
      }
      await dispatch(updateDryingLog(selectedMoistureLog.id, params));
      setMoistureLogRefetch(true);
      onCloseModal();
    }
  }, [selectedRoomId, selectedMoistureLog, latestAverage, removed, recordTime]);

  return (
    <EditMoistureLogReadingModal
      isOpen={isEditMoistureLogReadingModalOpen}
      closeModal={onCloseModal}
      formErrors={{}}
      removed={removed}
      isProcessing={isProcessing}
      latestAverage={latestAverage}
      recordTime={recordTime}
      onChangeLatestAverage={onChangeLatestAverage}
      onRemovedCheckboxClick={onRemovedCheckboxClick}
      onSaveButtonClick={onSaveButtonClick}
      onChangeRecordTime={setRecordTime}
    />
  );
}

const EditMoistureLogReadingModalMemo = memo(EditMoistureLogReadingModalContainer, areEqual);

export { EditMoistureLogReadingModalMemo as EditMoistureLogReadingModal };
